import { init_menu_accessibility, update_menu } from '../modules/menu';
import { sliders } from '../modules/sliders';
import { setup_scrolling, sidebar } from '../modules/page';
import { active_section } from '../modules/waypoints';
import { rerun_gravity_forms_scripts } from '../modules/forms';
import {accordionLinks} from '../modules/accordionLinks';

export default {
	init() {
		// JavaScript to be fired on all pages
		update_menu();
		init_menu_accessibility();
		setup_scrolling();
		sliders();
		rerun_gravity_forms_scripts();
		sidebar();
		accordionLinks();

		let delay = $('.swup-enabled').hasClass('is-rendering') ? 400 : 0;

		setTimeout(() => {
			active_section();
		}, delay );
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js